module.exports = __webpack_public_path__ + "img/VC.583380d3.png";